import styled from 'styled-components';

const Headline = styled.h1`
  margin-bottom: 2rem;
`;

export default Headline;
